'use client'
import { CpfMask, CnpjMask, Table, TableRow, TableHeader, TableCell, TextInput, TextInputMask, TextInputUpperCase, TextArea, CheckboxItem, ColorButton, ChangePassword, ReplyMessage } from "@/components/ui";
import { AtSign, Smile, User, Text, SquareCheck, Contact, Lock } from "@/assets/icons";
import { useActionState, useEffect, useState } from "react";
import { defaultUser, UserIdResponseType } from "@/types";
import { getUserId, updateUserForm } from "@/app/api";
import { useRouter } from "next/navigation";
import Form from "next/form";

export function UpdateUser({ id }: { id: string }) {
    const [state, formAction, pending] = useActionState(updateUserForm, {
        values: { id: '', code: '', identifier: '', name: '', userName: '', email: '', observation: '', userType: '' },
        errors: {},
        message: '',
    })

    const [isOpen, setIsOpen] = useState<boolean>(false)

    const [userData, setUserData] = useState<UserIdResponseType>()

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getUserId(id)
                if (response !== undefined) {
                    setUserData(response)
                }
            } catch (e) {
                console.log('Não foi possível buscar o usuário: ', e)
            }
        }

        fetchUser()
    }, [id])
    const user = userData || defaultUser

    const router = useRouter();

    if (state.success?.valueOf() === true) {
        setTimeout(() => {
            router.back();
        }, 1000);
    }

    const userIdentifier = user.identifier.length <= 11 ? CpfMask(user.identifier) : CnpjMask(user.identifier)

    return (
        <div>
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableHeader>Empresa</TableHeader>
                            <TableHeader>Nome</TableHeader>
                            <TableHeader>Email</TableHeader>
                            <TableHeader>CPF/CNPJ</TableHeader>
                            <TableHeader>Tipo</TableHeader>
                            <TableHeader>Data do cadastro</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{user.code}</TableCell>
                            <TableCell>{user.userName}</TableCell>
                            <TableCell>{user.name}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{userIdentifier}</TableCell>
                            <TableCell>
                                {user.role === 'ADMIN' ? 'Admin'
                                    : user.role === 'CLIENT' ? 'Cliente'
                                        : user.role === 'SELLER' ? 'Vendedor'
                                            : user.role === 'ACCOUNTANT' ? 'Contador'
                                                : user.role === 'INACTIVE' ? 'Inativo'
                                                    : user.role === 'CANCELED' ? 'Cancelado'
                                                        : 'Usuário'
                                }
                            </TableCell>
                            <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableHeader>Observação</TableHeader>
                            <TableCell colSpan={6}>{user.observation}</TableCell>
                            <TableCell>
                                <button onClick={() => setIsOpen(true)}>
                                    <Lock />
                                </button>
                            </TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableCell>{user.code}</TableCell>
                            <TableHeader>Empresa</TableHeader>
                            <TableCell>{user.userName}</TableCell>
                            <TableHeader>Nome</TableHeader>
                            <TableCell>{user.name}</TableCell>
                            <TableHeader>Email</TableHeader>
                            <TableCell>{user.email}</TableCell>
                            <TableHeader>CPF/CNPJ</TableHeader>
                            <TableCell>{userIdentifier}</TableCell>
                            <TableHeader>Tipo</TableHeader>
                            <TableCell>
                                {user.role === 'ADMIN' ? 'Admin'
                                    : user.role === 'CLIENT' ? 'Cliente'
                                        : user.role === 'SELLER' ? 'Vendedor'
                                            : user.role === 'ACCOUNTANT' ? 'Contador'
                                                : user.role === 'INACTIVE' ? 'Inativo'
                                                    : user.role === 'CANCELED' ? 'Cancelado'
                                                        : 'Usuário'
                                }
                            </TableCell>
                            <TableHeader>Data do cadastro</TableHeader>
                            <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>
                            <TableHeader>Observação</TableHeader>
                            <TableCell>{user.observation}</TableCell>
                            <TableCell className="border-t-2 min-w-40 border-ochre_accent" />
                            <TableCell>
                                <button onClick={() => setIsOpen(true)}>
                                    <Lock />
                                </button>
                            </TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <Form action={formAction} className="flex flex-col gap-3">

                <input type="hidden" name="id" defaultValue={user.id} />

                {/* code of user */}

                <div className="flex gap-2 items-center">
                    <User className="size-4" />
                    <label htmlFor="code">Código</label>
                </div>
                <TextInput name="code" id="code"
                    minLength={4} maxLength={4}
                    required
                    defaultValue={user.code || state?.values?.code}
                    placeholder="CPF/CNPJ" />
                {state?.errors?.code && <p>{state.errors.code}</p>}

                {/* cpf or cnpj of user */}

                <div className="flex gap-2 items-center">
                    <User className="size-4" />
                    <label htmlFor="identifier">CPF/CNPJ</label>
                </div>
                <TextInputMask name="identifier" id="identifier"
                    minLength={11} maxLength={18}
                    required
                    value={user.identifier || state?.values?.identifier}
                    placeholder="CPF/CNPJ" />
                {state?.errors?.identifier && <p>{state.errors.identifier}</p>}

                {/* username of user */}

                <div className="flex gap-2 items-center">
                    <Contact className="size-4" />
                    <label htmlFor="userName">Empresa</label>
                </div>
                <TextInputUpperCase name="userName" id="userName"
                    required
                    value={user.userName || state?.values?.userName}
                    placeholder="Empresa" />
                {state?.errors?.userName && <p>{state.errors.userName}</p>}

                {/* name of user */}

                <div className="flex gap-2 items-center">
                    <Smile className="size-4" />
                    <label htmlFor="name">Nome</label>
                </div>
                <TextInput name="name" id="name"
                    required
                    defaultValue={user.name || state?.values?.name}
                    placeholder="Nome" />
                {state?.errors?.name && <p>{state.errors.name}</p>}

                {/* email of user */}

                <div className="flex gap-2 items-center">
                    <AtSign className="size-4" />
                    <label htmlFor="email">Email</label>
                </div>
                <TextInput name="email" id="email"
                    required
                    defaultValue={user.email || state?.values?.email}
                    placeholder="Email" />
                {state?.errors?.email && <p>{state.errors.email}</p>}

                {/* observation of user */}

                <div className="flex gap-2 items-center">
                    <Text className="size-4" />
                    <label htmlFor="observation">Observação</label>
                </div>
                <TextArea name="observation" id="observation"
                    defaultValue={user.observation || state?.values?.observation}
                    placeholder="Observação" />
                {state?.errors?.observation && <p>{state.errors.observation}</p>}

                {/* type of user */}

                <div className="flex gap-2 items-center">
                    <SquareCheck className="size-4" />
                    <label htmlFor="userType">Tipo de usuário</label>
                </div>
                <div className="flex flex-wrap gap-5">
                    <CheckboxItem name="userType"
                        value="admin" label="Administrador"
                        defaultChecked={user.role === 'ADMIN' || state?.values?.userType === 'admin'}
                    />

                    <CheckboxItem name="userType"
                        value="client" label="Cliente"
                        defaultChecked={user.role === 'CLIENT' || state?.values?.userType === 'client'}
                    />


                    <CheckboxItem name="userType"
                        value="seller" label="Vendedor"
                        defaultChecked={user.role === 'SELLER' || state?.values?.userType === 'seller'}
                    />


                    <CheckboxItem name="userType"
                        value={"accountant"} label="Contador"
                        defaultChecked={user.role === 'ACCOUNTANT' || state?.values?.userType === 'accountant'}
                    />

                    <CheckboxItem name="userType"
                        value={"inactive"} label="Inativo"
                        defaultChecked={user.role === 'INACTIVE' || state?.values?.userType === 'inactive'}
                    />

                    <CheckboxItem name="userType"
                        value={"canceled"} label="Cancelado"
                        defaultChecked={user.role === 'CANCELED' || state?.values?.userType === 'canceled'}
                    />
                </div>
                {state?.errors?.userType && <p>{state.errors.userType}</p>}

                {/* submit */}

                <div className="flex flex-col gap-3 p-4  items-center justify-center">
                    <ColorButton type="submit" disabled={pending}>
                        {pending ? 'Atualizando...' : 'Atualizar'}
                    </ColorButton>
                </div>

            </Form>

            {isOpen &&
                <ChangePassword
                    user_id={user.id}
                    title={"Alteração de senha"}
                    message={"Defina a nova senha para o usuário: "}
                    identifier={`${user.code}-${user.userName} (${user.name})`}
                    onClose={() => setIsOpen(false)}
                />
            }

            <ReplyMessage message={state?.message || ""} />
        </div>
    )
}